import React, { Component } from "react";
import PropTypes from "prop-types";
import { GUIDES_TAB_HEADER_COLOR, GUIDES_TITLE_NAME } from "../../../helpers/constants";

import suitcase from "../../../assets/images/guides/suitcase.png";

import GuidesHeader from "../../../components/molecules/GuidesHeader";
import { fetchGhostPostBySlug } from "../../../helpers/ghost";
import StyledLoading from "../../../components/atoms/Loading/StyledLoading";
import urlPatterns from "../../../urls";
import { header } from "../../../styles/variables";
import GuidesTabNavigator from "../../../components/molecules/GuidesTabNavigator";
import GuidesDetailMain from "../../../components/molecules/GuidesTabPages/GuidesDetailMain";

class GuidesTabRegionDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      post: null,
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    if (slug) {
      const post = await fetchGhostPostBySlug(slug);
      this.setState({ post, loading: false });
    }
  }

  render() {
    const { match, location } = this.props;
    const { post, loading } = this.state;

    if (loading) return <StyledLoading />;

    const { title } = post || {};
    const { url } = match || {};

    return (
      <>
        <GuidesHeader
          headerIcon={suitcase}
          headerColor={GUIDES_TAB_HEADER_COLOR.GUIDE_REGION}
          headerTitle={title || GUIDES_TITLE_NAME.GUIDE_REGION}
        />
        <GuidesTabNavigator
          mobileHeaderStyleTop={header.mobileHeight}
          shouldDisappearOnMobile
          backgroundColor={GUIDES_TAB_HEADER_COLOR.GUIDE_REGION}
          urlRegion={url}
          location={location}
        />
        <GuidesDetailMain
          post={post}
          parentLabel="Region Guides"
          parentUrl={urlPatterns.GUIDE_REGION}
          isFromTabRegion
          location={location}
        />
      </>
    );
  }
}

GuidesTabRegionDetails.propTypes = {
  match: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesTabRegionDetails;
